<template>
  <div v-if="isDetailLoading || !selectedDetenido">
    <div class="loading-container">
      <ProgressSpinner
        style="width: 50px; height: 50px"
        strokeWidth="5"
        fill="#EEEEEE"
        animationDuration="1.5s"
        class="loading-spinner"
      />
    </div>
  </div>
  <div v-else class="detalle-card">
    <div class="detalle-header flex justify-content-start align-items-center gap-4">
      <h2 class="detalle-title">
        {{ selectedDetenido.UfiOJuzgado }} - {{ selectedDetenido.NumeroActuacion }} -
        {{ selectedDetenido.DependenciaNombre }}
      </h2>
      <span class="estado-pill" :class="estadoPillClass(selectedDetenido.EstadoActual)">
        {{ estadoLabel(selectedDetenido.EstadoActual) }}
      </span>
    </div>

    <div class="detalle-grid">
      <div
        v-for="field in detailFields"
        :key="field.key"
        class="detalle-item"
        :class="field.span === 2 ? 'detalle-item--span-2' : ''"
      >
        <span class="detalle-label">{{ field.label }}</span>
        <span class="detalle-value">
          {{
            field.key === "Edad"
              ? calcularEdadDesdeFecha(selectedDetenido.FechaDeNacimiento)
              : field.key === "TieneEstudios" || field.key === "ExhibeDocumento"
                ? formatSiNo(selectedDetenido[field.key])
                : selectedDetenido[field.key]
                  ? selectedDetenido[field.key]
                  : "-"
          }}
        </span>
      </div>
    </div>
    <h2 class="title-detail" v-if="selectedDetenido.EstadoActual === 'EN_CALABOZO'">
      Detalle del detenido recibido
    </h2>
    <h2 class="title-detail" v-if="selectedDetenido.EstadoActual === 'LIBERADO'">
      Datos cargados por el calabocero
    </h2>
    <div
      class="detalle-grid2"
      v-if="
        selectedDetenido.EstadoActual === 'EN_CALABOZO' ||
        selectedDetenido.EstadoActual === 'LIBERADO'
      "
    >
      <div
        v-for="field in detailFields2"
        :key="field.key"
        class="detalle-item"
        :class="field.span === 2 ? 'detalle-item--span-2' : ''"
      >
        <span
          class="detalle-label"
          :class="
            field.estado === 'LIBERADO' && selectedDetenido.EstadoActual === 'EN_CALABOZO'
              ? 'hidden'
              : ''
          "
          >{{ field.label }}</span
        >
        <span class="detalle-value">
          {{
            field.estado === "LIBERADO" && selectedDetenido.EstadoActual === "EN_CALABOZO"
              ? ""
              : field.key === "FechaIngreso" || field.key === "FechaHoraEgreso"
                ? formatDateTime(selectedDetenido[field.key])
                : (selectedDetenido[field.key] ?? "-")
          }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { storeToRefs } from "pinia";
import { useCalabozoStore } from "@/store/Pinia/useCalabozoStore";
import ProgressSpinner from "primevue/progressspinner";

const calabozoStore = useCalabozoStore();

const props = defineProps({
  detencionID: {
    type: String,
    required: true,
  },
});

const { selectedDetenido, isDetailLoading } = storeToRefs(calabozoStore);
const emit = defineEmits(["volver"]);

const detailFields = [
  { label: "Tipo de vinculado", key: "tipoVinculado" },
  { label: "Tipo de documento", key: "TipoDocumentoID" },
  { label: "Número de identificación", key: "NumeroIdentificacion" },
  { label: "Sexo", key: "Sexo" },
  { label: "Número de CUIL", key: "Cuil" },
  { label: "Apellido", key: "Apellido" },
  { label: "Nombre", key: "Nombre" },
  { label: "Edad", key: "Edad" },
  { label: "Exhibe documento", key: "ExhibeDocumento" },
  { label: "Fecha de nacimiento", key: "FechaDeNacimiento" },
  { label: "Nacionalidad", key: "Nacionalidad" },
  { label: "Estado civil", key: "EstadoCivil" },
  { label: "Teléfono", key: "Telefono" },
  { label: "Email", key: "Email" },
  { label: "Profesión", key: "Profesion" },
  { label: "Domicilio", key: "DomicilioSipe" },
  { label: "Tiene estudios?", key: "TieneEstudios" },
  { label: "Instrucciones", key: "Instruccion" },
  { label: "Observaciones", key: "Observaciones", span: 2 },
];

const detailFields2 = [
  { label: "Fecha y hora del ingreso al calabozo", key: "FechaIngreso" },
  { label: "Estado de salud visualmente", key: "EstadoVisual" },
  { label: "Objetos retenidos", key: "EfectosRetenidos", span: 2 },
  { label: "Fecha y hora de egreso al calabozo", key: "FechaHoraEgreso", estado: "LIBERADO" },
  { label: "Forma de liberación", key: "FormaLiberacion", estado: "LIBERADO" },
  { label: "Autoridad que autoriza la salida", key: "UfiOJuzgado", estado: "LIBERADO" },
  { label: "Motivos", key: "MotivoLiberacion", estado: "LIBERADO" },
];

const estadoPillClass = (estado) => {
  if (!estado) return "";
  if (estado === "EN_CALABOZO") return "estado-pill--calabozo";
  if (estado === "PENDIENTE") return "estado-pill--pendiente";
  if (estado === "LIBERADO") return "estado-pill--liberado";
  return "";
};

const estadoLabel = (estado) => {
  if (!estado) return "";
  if (estado === "EN_CALABOZO") return "En calabozo";
  if (estado === "PENDIENTE") return "Pendiente";
  if (estado === "LIBERADO") return "Liberado";
  return "";
};

const formatSiNo = (value) => {
  if (value === 1 || value === true || value === "1") return "Sí";
  if (value === 0 || value === false || value === "0") return "No";
  return "-";
};

const calcularEdadDesdeFecha = (fechaStr) => {
  if (!fechaStr || typeof fechaStr !== "string") return "-";

  const normalizada = fechaStr.replaceAll("\\/", "/").trim();

  const match = normalizada.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (!match) return "-";

  const dia = Number(match[1]);
  const mes = Number(match[2]);
  const anio = Number(match[3]);
  const nacimiento = new Date(anio, mes - 1, dia);

  if (
    Number.isNaN(nacimiento.getTime()) ||
    nacimiento.getFullYear() !== anio ||
    nacimiento.getMonth() !== mes - 1 ||
    nacimiento.getDate() !== dia
  ) {
    return "-";
  }

  const hoy = new Date();
  let edad = hoy.getFullYear() - anio;

  const yaCumplio =
    hoy.getMonth() > mes - 1 || (hoy.getMonth() === mes - 1 && hoy.getDate() >= dia);

  if (!yaCumplio) edad -= 1;

  if (edad < 0) return "-";

  return edad;
};

const formatDateTime = (input) => {
  const date = new Date(input);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}Hs`;
};

onMounted(async () => {
  await calabozoStore.loadDetenidoDetalle(props.detencionID, true);
});
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Ubuntu:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400;1,500;1,700&display=swap");

.detalle-card {
  width: 100%;
  padding: 1.5rem 2rem;
  border-radius: 12px;
  background-color: #ffffff;
  box-shadow: 0px 4px 4px 0px #00000040;
}
.loading-container {
  display: flex;
  align-items: center;
  z-index: 1;

  padding: 15px 20px;
  border-radius: 10px;
}

.detalle-header {
  margin-bottom: 1.5rem;
}

.detalle-title {
  font-family: "IBM Plex Sans";
  font-weight: 500;
  font-style: Medium;
  font-size: 24px;
  line-height: 100%;
  text-align: center;
  vertical-align: middle;
  color: #000000;
}

.estado-pill {
  padding: 4px 12px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 500;
}

.estado-pill--calabozo {
  background-color: #feebeb;
  color: #e10e0e;
}

.estado-pill--pendiente {
  background-color: #fffbeb;
  color: #d97706;
}

.estado-pill--liberado {
  background-color: #daf8e6;
  color: #1a8245;
}

.detalle-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 0.75rem 2rem;
}

.detalle-grid2 {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.75rem 2rem;
}
.title-detail {
  font-family: "IBM Plex Sans";
  font-weight: 700;
  font-style: Bold;
  font-size: 24px;
  line-height: 100%;
  color: #000000;
}

.detalle-item {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.detalle-item--span-2 {
  grid-column: span 2;
}

.detalle-label {
  color: #000000;
  font-family: "Ubuntu";
  font-weight: 700;
  font-style: Bold;
  font-size: 18px;
  line-height: 30px;
  letter-spacing: 0%;
}

.detalle-value {
  font-family: "Ubuntu";
  font-weight: 400;
  font-style: "Regular";
  font-size: 18px;
  line-height: 30px;
  letter-spacing: 0%;
  color: #000000;
}
</style>
